import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator,
    Platform,
    KeyboardAvoidingView,
    TouchableOpacity,
    Alert,
    BackHandler,
    ScrollView,
    I18nManager,
    Image
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store/index";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError
} from "./action/ActionListTaskOperationSatiaScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import HMDialogSelectDate from "../../../../customviews/HMDialogSelectDate";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMButton from "../../../../customviews/HMButton";
import HMIcon from "../../../../customviews/HMIcon";
import DialogLoadingCustomize from "../../../../customviews/DialogLoadingCustomize";
import HMModalSearch from "../../../../customviews/HMModalSearch";
import HMRecycleView from "../../../../customviews/HMRecycleView";
import {DataProvider, LayoutProvider} from "recyclerlistview";
import HMImageView from "../../../../customviews/HMImageView";
import moment from "moment-jalaali";
import * as NavigationService from "../../../../redux/NavigationService";
import HMModal from "../../../../customviews/modal/HMModal";
import HMSelectInput from "../../../../customviews/HMSelectInput";
import PathFile from "../../../../assets/PathFile";
import {isMobile} from "react-device-detect";
import HMTextInput from "../../../../customviews/HMTextInput";
import HMSelectTimeFooter from "../../../../customviews/HMSelectTimeFooter";
import HMFlatList from "../../../../customviews/HMFlatList";
//import {withNavigationFocus} from "react-navigation";
//import {withNavigationFocus} from '@react-navigation/'

moment.locale("fa");
moment.loadPersian();
let container = null;
let requestFirst = false;
let HeightItem = moderateScale(50);

class ListTaskOperationSatiaScreen extends Component {
    constructor(props) {
        super(props);
        //console.log("ahmad=>props", props)
        let {Extras, data, type, mode, arraySelected, DateFrom, DateTo, indexSelectMonthTypeExtras} = props.route && props.route.params ? props.route?.params : props;
        let {beginDate, endDate, indexSelectMonthType} = props.DataSplashSatiaScreen;


        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let lat = 0
        let long = 0
        if (!myLocation) {
            lat = parseFloat(myLocation ? myLocation.coords.latitude : 0);
            long = parseFloat(myLocation ? myLocation.coords.longitude : 0);
            // long = parseFloat(props.navigation && props.route.params ? props.route.params.position.coords.longitude : props.position ? props.position.coords.longitude : 0);

        }

        let viewportWidth = 1;
        let viewportHeight = 1;
        let columnCount = 1;
        if (Platform.OS === "web") {
            viewportWidth = document.body.clientWidth;
            viewportHeight = document.body.clientHeight;
            columnCount = viewportWidth > 1000 ? 2 : 1;

        }


        // let endDate = moment().format('jYYYY/jM/jD');
        //
        // let m = moment(endDate, 'jYYYY/jM/jD');
        //
        // let startDate = m.subtract(3, 'month').locale('fa').format('jYYYY/jM/jD');
        this.state = {
            DateFrom: DateFrom ? DateFrom : beginDate,
            DateTo: DateTo ? DateTo : endDate,
            dataProvider: new DataProvider((r1, r2) => {
                return r1.row !== r2.row;
            }),
            layoutProvider: new LayoutProvider(
                (i) => {
                    return 'VSEL'; //Since we have just one view type
                },
                (type, dim, index) => {
                    switch (type) {
                        case 'VSEL':
                            dim.width = viewportWidth;
                            dim.height = moderateScale(85);
                            //dim.width = 0;
                            // if (index % 3 === 0) {
                            //     dim.width = 3 * columnWidth;
                            //     dim.height = 300;
                            // } else if (index % 2 === 0) {
                            //     dim.width = 2 * columnWidth;
                            //     dim.height = 250;
                            // } else {
                            //     dim.width = columnWidth;
                            //     dim.height = 250;
                            // }
                            break;
                        default:
                            dim.width = 0;
                            dim.height = 0;
                    }
                }
            ),
            columnCount: columnCount,
            viewportWidth: Platform.OS === "web" ? viewportWidth : typeExport._WIDTH,
            itemWidth: Platform.OS === "web" ? (viewportWidth > 600 ? 480 : viewportWidth) : typeExport._WIDTH,

            Period: null,
            indexSelectMonthType: indexSelectMonthType || indexSelectMonthType == 0 ? indexSelectMonthType : 1,
            listFilter: [],
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,

            lat: lat,
            long: long,
            dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                name: 'در دست اقدام',
                id: 2
            }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                name: 'تایید واحد',
                id: 5
            },],
            textCondition: null,
            arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                name: 'تکراری در دست اقدام',
                id: 3
            }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],
            Condition: {id: 0, value: "وضعیت پیام"},

            arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: arraySelected && arraySelected.length > 0 ? arraySelected : [],
            searchText: null,
            resultModal: null,

            SortFilter: null,
            SelectSortFilter: null,
            listSortFilter: [
                {
                    id: 1, value: 'done', label: 'انجام شده ها',
                },
                {
                    id: 1, value: 'doing', label: 'در دست اقدام',
                },
                {
                    id: 2, value: 'other', label: 'سایر',
                },
            ],
            OrderFilter: null,
            SelectOrderFilter: null,
            listOrderFilter: [
                {
                    id: 1, value: 'asc', label: 'صعودی',
                }, {
                    id: 2, value: 'desc', label: 'نزولی',
                },
            ],
            typeOrder: "desc",
            typeSort: "count",
            alaki: false,
        };
        container = this;

        // store.dispatch(serviceActionListFilter([]))
        // this.props.callserviceActionRefresh();
        // this.getData(1)

        // if (listFilter && listFilter.length > 0)
        //     store.dispatch(serviceActionListFilter(listFilter))


    }

    state = {
        show: false
    };

    componentDidUpdate(prevProps) {
        if (prevProps.isFocused !== this.props.isFocused) {
            //alert("sdfkhvdsfj")
            // Use the `this.props.isFocused` boolean
            // Call any action
        }
    }

    componentWillReceiveProps(propss) {
    }


    componentDidMount() {

        this.props.navigation.addListener('focus', () => {
                container = this;
                this.setState({
                    alaki: !this.state.alaki
                })
                // alert("fgh")

                if (global._refreshListTaskOperationSatia) {
                    requestFirst = true;
                    store.dispatch(serviceActionListFilter([]))
                    this.props.callserviceActionRefresh();
                    this.getData(1)
                }

            }
        )
        this.props.navigation.addListener('blur', () => {
                // store.dispatch(serviceActionListFilter([]))
                // props.callserviceActionRefresh();
            }
        )

        if (!requestFirst) {
            store.dispatch(serviceActionListFilter([]))
            this.props.callserviceActionRefresh();
            this.getData(1)
        }
        /*     this.setState({
                 layoutProvider: new LayoutProvider(
                     () => {
                         return 'VSEL'; //Since we have just one view type
                     },
                     (type, dim, index) => {
                         const columnWidth = this.state.viewportWidth;
                         switch (type) {
                             case 'VSEL':
                                 dim.width = columnWidth;
                                 dim.height =  moderateScale(85);
                                 //dim.width = 0;
                                 // if (index % 3 === 0) {
                                 //     dim.width = 3 * columnWidth;
                                 //     dim.height = 300;
                                 // } else if (index % 2 === 0) {
                                 //     dim.width = 2 * columnWidth;
                                 //     dim.height = 250;
                                 // } else {
                                 //     dim.width = columnWidth;
                                 //     dim.height = 250;
                                 // }
                                 break;
                             default:
                                 dim.width = 0;
                                 dim.height = 0;
                         }
                     }
                 ),
             })*/
        if (Platform.OS === "web")
            window.addEventListener("resize", function (event) {
                const IS_IOS = Platform.OS === 'ios';
                let viewportWidth = document.body.clientWidth;
                let viewportHeight = document.body.clientHeight;


                container.setState({
                        viewportWidth: viewportWidth,
                        itemWidth: viewportWidth > 600 ? 480 : viewportWidth,
                        columnCount: viewportWidth > 1000 ? 2 : 1,
                    },
                )


            })
    }

    componentWillUnmount() {

    }

    async getData(page) {
        let {Extras, data, type, mode} = this.props.route && this.props.route.params ? this.props.route.params : this.props;
        let after = "0000-00-00";
        //   this.props.callService(urlListTaskOperationSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListTaskOperationSatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListTaskOperationSatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListTaskOperationSatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListTaskOperationSatiaScreen, _GET, page, 10)
  */

        let paramss = {

            "lang": i18n.locale,
            "token": store.getState().reducerSplashSatiaScreen.token,
            "page": page,
            "type": Extras.type ? Extras.type : null,
            "id": type && Extras ? Extras.id : null,
            "name": type && Extras ? Extras.name : null,

            "month": this.state.Period,
            //  beginDate=1399/5/24&endDate=1399/6/13
            //     DateTo={this.state.DateTo}
            // DateFrom={this.state.DateFrom}
            // "beginDate": this.state.DateTo,
            // "endDate": this.state.DateFrom,
            "beginDate": this.state.DateFrom,
            "endDate": this.state.DateTo,
            "typeSort": this.state.typeSort,
            "typeOrder": this.state.typeOrder,
            "listFilter": this.state.arraySelected,
            "searchText": this.state.searchText,
        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            this.props.callService(typeExport._baseUrlSatia + (Extras.type == 4 ? "operator_tk/myTasksCreator" : "operator_tk/myTasks"), paramss, typeExport.TypeGetListTaskOperationSatiaScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    _onMapReady = () => this.setState({marginBottom: 0})

    _setStateData(object) {
        container.setState(object);
    }

    render() {
        let {Extras, data, type, mode} = this.props.Extras ? this.props : this.props.route.params;
        let {beginDate, endDate} = this.props.DataSplashSatiaScreen;
        let CustomView = mode ? TouchableOpacity : View;
        //  let item = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.item : this.props.item;
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        let heightSlider = (this.state.viewportWidth > 600) ? 500 : (Platform.OS === "web" ? this.state.viewportWidth : typeExport.WIDTH) / 1.6;
        let widthSlider = this.state.viewportWidth - moderateScale(Platform.OS === "web" && !(isMobile) ? moderateScale(15) : 0);

        // let widthSlider = this.state.viewportWidth;
        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1,}}>


                {/*<HMImageBackground*/}

                {/*/>*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        {
                            this.props.Extras ?
                                null
                                :
                                <HMActionBarSatia
                                    //exit={true}
                                    menu
                                    back

                                    props={this.props} statusBarTransparent
                                    // text={i18n.t('ListServiceHistorySatia.title')}
                                    text={(Extras && Extras.name ? Extras.name : (Extras && Extras.title ? Extras.title : 'سوابق خرید آنلاین'))}
                                    //text={(data.name ? data.name : (data.title ? data.title : ''))}
                                    //  text={this.state.arraySelected.length}


                                    //  text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}

                                />
                        }

                        <View style={{flex: 1}}>

                            <View style={{flex: 1}}>
                                <View
                                    style={{
                                        height: moderateScale(42),
                                        backgroundColor: Colors.colorPrimary,
                                        flexDirection: 'row',
                                        marginHorizontal: moderateScale(10),
                                        marginTop: moderateScale(6),
                                        borderRadius: moderateScale(14),
                                        borderColor: Colors.colorDark,
                                        borderWidth: moderateScale(1),
                                        //  marginBottom: moderateScale(10)
                                        // width:'100%'
                                    }}>

                                    <View
                                        style={{
                                            flex: .8,
                                            height: moderateScale(40),
                                            backgroundColor: Colors.white,
                                            borderRadius: moderateScale(14),
                                            flexDirection: 'row',
                                            paddingHorizontal: moderateScale(4),
                                            alignItems: 'center',

                                        }}>

                                        <View style={{width: moderateScale(5)}}/>

                                        <View style={{flex: 1, marginHorizontal: moderateScale(8)}}>
                                            <HMTextInput value={this.state.searchText}
                                                         onChangeText={(text) => this.setState({searchText: text}, () => {
                                                             //  this.getJsonMap()

                                                         })}
                                                         _height={40}
                                                //  autoFocus
                                                //  placeholder={i18n.t('constant.filter')}
                                                         placeholder={" ... " + i18n.t('constant.Search')}
                                                         NoShowPlaceholder
                                                //باتد_width={'80%'}
                                                // icon={"md-person"}
                                                         style={{
                                                             fontSize: moderateScale(13),

                                                             // marginTop: moderateScale(6)
                                                         }} underlineColorAndroid="transparent"/>
                                        </View>
                                        {/*{*/}
                                        {/*this.state.loadingAddressMarker ?*/}
                                        {/*<ActivityIndicator color={Colors.colorPrimary}*/}
                                        {/*size={"large"}/>*/}

                                        {/*:*/}
                                        {/*<HMTextView*/}
                                        {/*numberOfLines={1}*/}
                                        {/*onPress={() => HMAlert(*/}
                                        {/*i18n.t('constant.address'),*/}
                                        {/*this.state.addressMap,*/}
                                        {/*[*/}
                                        {/*// {text: 'Ask me later', onPress: () => {}},*/}
                                        {/*// {text: 'Cancel', onPress: () => {}, style: 'cancel'},*/}
                                        {/*{*/}
                                        {/*text: i18n.t('constant.ok'), onPress: () => {*/}
                                        {/*}*/}
                                        {/*},*/}
                                        {/*],*/}
                                        {/*{cancelable: true}*/}
                                        {/*)}*/}
                                        {/*//text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}*/}
                                        {/*text={this.state.addressMap}*/}
                                        {/*type={"bold"} style={{*/}
                                        {/*//textAlign: "center",*/}
                                        {/*color: Colors.gray,*/}
                                        {/*fontSize: moderateScale(11),*/}
                                        {/*marginEnd: moderateScale(3)*/}


                                        {/*// flex:1*/}
                                        {/*}}/>*/}
                                        {/*}*/}

                                    </View>
                                    <TouchableOpacity
                                        onPress={() => {
                                            this.getData(1)
                                            //  this.nextScreen(item, type)
                                        }}
                                        style={{
                                            flex: .2,
                                            height: moderateScale(32),
                                            backgroundColor: Colors.colorPrimary,
                                            borderTopEndRadius: moderateScale(14),
                                            borderBottomEndRadius: moderateScale(14),
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>

                                        <HMTextView
                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                            text={i18n.t('constant.Search')}
                                            type={"bold"}
                                            style={{
                                                textAlign: "center",
                                                color: Colors.white,
                                                fontSize: moderateScale(13)

                                            }}/>
                                    </TouchableOpacity>

                                </View>
                                <HMSelectTimeFooter
                                    DateTo={this.state.DateTo}
                                    DateFrom={this.state.DateFrom}
                                    arraySelected={this.state.arraySelected}
                                    indexSelectMonthType={this.state.indexSelectMonthType}
                                    showDialogDate={this.state.showDialogDate}
                                    func={() => this.getData(1)}
                                    _setStateData={container._setStateData}
                                />
                                {/* <View style={{width: "98%", alignSelf: "center", marginVertical: moderateScale(6),}}>
                                    <View style={{padding: moderateScale(4)}}>


                                        <FlatList
                                            // style={{height: moderateScale(36)}}
                                            //    data={result.items}
                                            // data={this.props.ListFilter ? this.props.ListFilter : []}
                                            data={[
                                                {
                                                    type: '1',
                                                    image: PathFile.base64Image.Month1,
                                                },

                                                {
                                                    type: '3',
                                                    image: PathFile.base64Image.Month3,

                                                },
                                                {
                                                    type: '6',
                                                    image: PathFile.base64Image.Month6,

                                                },
                                                {
                                                    type: 'D',
                                                    image: PathFile.base64Image.SelectDate,
                                                },

                                                // {
                                                //
                                                //     type: '3',
                                                //     name: 'تاریخ',
                                                // },

                                            ]}
                                            //   numColumns={3}
                                            renderItem={({item, index}) => {

                                                //let checkIndex = this.checkSelect(item, index);
                                                // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
                                                let idx = this.state.arraySelected.findIndex(obj => obj.index === index);
                                                let checkIndex = (idx !== -1);


                                                return <TouchableOpacity
                                                    onPress={() => {
                                                        let endDate = this.state.DateTo;
                                                        let m = null;
                                                        let startDate = this.state.DateFrom;


                                                        if (item.type !== "D") {
                                                            endDate = moment().format('jYYYY/jM/jD');
                                                            m = moment(endDate, 'jYYYY/jM/jD');
                                                            startDate = m.subtract(item.type, 'month').locale('fa').format('jYYYY/jM/jD');
                                                        }

                                                        this.setState({
                                                                indexSelectMonthType: index,
                                                                type: item.id,
                                                                month: item.type,
                                                                showDialogDate: item.type === "D",
                                                                DateFrom: startDate,
                                                                DateTo: endDate,
                                                            },
                                                            () => {
                                                                if (item.type !== "D")
                                                                    this.getData(1)
                                                            }
                                                        )

                                                    }
                                                    }
                                                    style={{
                                                        width: moderateScale(70),
                                                        height: moderateScale(70),
                                                        // paddingHorizontal: moderateScale(3),
                                                        //      backgroundColor: "#ee00e9",
                                                        borderRadius: moderateScale(4),
                                                        borderWidth: moderateScale(1),
                                                        borderColor: this.state.indexSelectMonthType == index ? Colors.blackLight : Colors.transparent,
                                                        marginHorizontal: moderateScale(2),
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <View style={{
                                                        width: moderateScale(60),
                                                        height: moderateScale(60),
                                                        // backgroundColor: "#0fbbee",
                                                    }}>
                                                        <Image resizeMode={'contain'} source={{
                                                            uri: 'data:image/png;base64,' + item.image,
                                                            //   uri:'data:image/png;base64,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',
                                                            scale: 1
                                                        }} style={{
                                                            width: "100%",
                                                            height: "100%",
                                                        }}/>

                                                    </View>

                                                </TouchableOpacity>

                                            }}
                                            horizontal={true}
                                            showsHorizontalScrollIndicator={false}
                                            keyExtractor={(item, index) => index.toString()}
                                            inverted={Platform.OS === 'android' && i18n.locale == 'fa'}


                                        />

                                    </View>
                                    <View style={{
                                        width: '100%',
                                        height: moderateScale(1),
                                        alignSelf: 'center',
                                        backgroundColor: Colors.light43
                                    }}/>
                                    <View style={{width: "100%", flexDirection: "row"}}>
                                        <View style={{width: "50%",}}>
                                            <FlatList
                                                // style={{height: moderateScale(36)}}
                                                //    data={result.items}
                                                data={this.props.ListFilter ? this.props.ListFilter : []}
                                                // data={[
                                                //     {
                                                //
                                                //         type: '1',
                                                //         name: 'وضعیت پیام',
                                                //
                                                //     },
                                                //     {
                                                //
                                                //         type: '2',
                                                //         name: 'واحد اجرایی',
                                                //     },
                                                //
                                                //     // {
                                                //     //
                                                //     //     type: '3',
                                                //     //     name: 'تاریخ',
                                                //     // },
                                                //
                                                // ]}
                                                //   numColumns={3}
                                                renderItem={this.renderItemFilter}
                                                //  horizontal={true}
                                                showsHorizontalScrollIndicator={false}
                                                keyExtractor={(item, index) => index.toString()}
                                                //inverted={Platform.OS === 'android' && i18n.locale == 'fa'}


                                            />
                                        </View>
                                        <View style={{width: "50%", alignItems: "center", justifyContent: "center"}}>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    this.setState({

                                                            showDialogDate: true,

                                                        },
                                                        () => {
                                                        }
                                                    )
                                                }}
                                            >
                                                <HMTextView
                                                    text={(this.state.DateTo || this.state.DateFrom ? this.state.DateFrom + " لغایت " + this.state.DateTo : "")}
                                                    type={"bold"}
                                                    style={{
                                                        marginHorizontal: moderateScale(6),
                                                        fontSize: moderateScale(14),
                                                        color: Colors.blue,
                                                        textDecorationLine: "underline",
                                                        textDecorationStyle: "solid",

                                                    }}/>
                                            </TouchableOpacity>
                                        </View>

                                    </View>


                                </View>*/}

                                <View style={{flex: 1}}>

                                    <EmptyView empty={this.props.empty}/>
                                    {
                                        // this.props.results && this.props.results.length > 0 ?
                                        //     <View style={{flex: 1}}>
                                        //         <HMRecycleView
                                        //
                                        //             style={{flex: 1, minHeight: 1, minWidth: 1}}
                                        //             contentContainerStyle={{}}
                                        //             onEndReached={this.handleLoadMore.bind(this)}
                                        //             dataProvider={this.state.dataProvider.cloneWithRows(this.props.results)}
                                        //             layoutProvider={this.state.layoutProvider}
                                        //             renderAheadOffset={0}
                                        //             canChangeSize={this.state.canChangeSize}
                                        //             forceNonDeterministicRendering={true}
                                        //             extendedState={{
                                        //                 heightSlider: heightSlider,
                                        //                 widthSlider: widthSlider,
                                        //                 l: this.props.results,
                                        //             }}
                                        //             onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                        //
                                        //
                                        //             //application
                                        //             rowRenderer={(type, item, index) => {
                                        //
                                        //                 if (Platform.OS !== "web") {
                                        //                     item = type.item;
                                        //                     index = type.index;
                                        //                 }
                                        //                 //if (index === 0)
                                        //                 return <View
                                        //                     style={{
                                        //                         width: widthSlider,
                                        //                         // flex: 1,
                                        //                         overflow: 'hidden',
                                        //                         //height: HeightItem,
                                        //                         // padding: moderateScale(4),
                                        //                         //  margin:moderateScale(5),
                                        //                         borderWidth: moderateScale(1),
                                        //                         // borderRadius: moderateScale(2),
                                        //                         borderColor: '#ddd',
                                        //                         // borderBottomWidth: 0,
                                        //                         // shadowColor: '#000',
                                        //                         // shadowOffset: {width: 0, height: moderateScale(.7)},
                                        //                         // shadowOpacity: 0.6,
                                        //                         // shadowRadius: moderateScale(2),
                                        //                         elevation: moderateScale(1),
                                        //                         // marginLeft: moderateScale(1),
                                        //                         // marginRight: moderateScale(1),
                                        //                         // marginTop: moderateScale(1),
                                        //                         // marginBottom: moderateScale(1),
                                        //                         backgroundColor: Colors.white,
                                        //                     }}>
                                        //                     <View
                                        //                         style={{
                                        //                             width: '100%',
                                        //                             flexDirection: 'row',
                                        //                             backgroundColor: Colors.white,
                                        //
                                        //
                                        //                             // alignSelf: 'center'
                                        //                             // marginVertical:moderateScale(6),
                                        //                         }}>
                                        //
                                        //                         <TouchableOpacity
                                        //                             style={{
                                        //                                 flex: .16,
                                        //                                 alignItems: 'center',
                                        //                                 justifyContent: 'center',
                                        //                                 marginVertical: moderateScale(6),
                                        //
                                        //                                 //  paddingHorizontal: moderateScale(4)
                                        //                             }}
                                        //                             onPress={() => {
                                        //                                 NavigationService.navigateParams("DetailsTaskOperationSatiaScreen", {
                                        //                                     item: item,
                                        //                                     itemExtra: item,
                                        //                                     itemExtraParent: Extras,
                                        //                                     // type: type,
                                        //                                     indexExtra: index
                                        //                                 })
                                        //                                 //   DetailsTaskOperationSatiaScreen
                                        //                             }}
                                        //                         >
                                        //                             <HMTextView
                                        //                                 // numberOfLines={2}
                                        //                                 type={"bold"}
                                        //                                 text={item.Name}
                                        //                                 style={{
                                        //                                     fontSize: moderateScale(13),
                                        //
                                        //                                     color: Colors.blackLight,
                                        //                                     // textDecorationLine: "underline",
                                        //                                     // textDecorationStyle: "solid",
                                        //                                     //  marginTop: moderateScale(4),
                                        //                                     //  textAlign: "right",
                                        //                                 }}/>
                                        //                         </TouchableOpacity>
                                        //                         <View style={{
                                        //                             height: Platform.OS === "web" ? "stretch" : "100%",
                                        //                             width: moderateScale(1),
                                        //                             backgroundColor: Colors.light43
                                        //                         }}/>
                                        //                         <View
                                        //                             style={{
                                        //                                 flex: .16,
                                        //                                 alignItems: 'center',
                                        //                                 justifyContent: 'center',
                                        //                                 marginVertical: moderateScale(2),
                                        //                                 //  paddingHorizontal: moderateScale(4)
                                        //                             }}
                                        //
                                        //                         >
                                        //                             <HMTextView
                                        //                                 // numberOfLines={2}
                                        //                                 type={"bold"}
                                        //                                 text={item.Title}
                                        //                                 style={{
                                        //                                     fontSize: moderateScale(13),
                                        //
                                        //                                     color: Colors.blackLight,
                                        //                                     // textDecorationLine: "underline",
                                        //                                     // textDecorationStyle: "solid",
                                        //                                     //  marginTop: moderateScale(4),
                                        //                                     //  textAlign: "right",
                                        //                                 }}/>
                                        //                         </View>
                                        //                         <View style={{
                                        //                             height: Platform.OS === "web" ? "stretch" : "100%",
                                        //                             width: moderateScale(1),
                                        //                             backgroundColor: Colors.light43
                                        //                         }}/>
                                        //
                                        //                         <CustomView
                                        //                             style={{
                                        //                                 flex: .14,
                                        //                                 alignItems: 'center',
                                        //                                 justifyContent: 'center'
                                        //                             }}
                                        //                             activeOpacity={mode ? .2 : 1}
                                        //                             onPress={() => {
                                        //                             }
                                        //                             }
                                        //                         >
                                        //                             <HMTextView
                                        //                                 // numberOfLines={2}
                                        //                                 type={"bold"}
                                        //                                 text={item.CreateTime_fa ? item.CreateTime_fa : " - "}
                                        //
                                        //                                 style={[{
                                        //                                     fontSize: moderateScale(14),
                                        //
                                        //
                                        //                                     //  marginTop: moderateScale(4),
                                        //                                     textAlign: "center",
                                        //
                                        //
                                        //                                 }, mode ? {
                                        //                                     color: Colors.blue,
                                        //                                     textDecorationLine: "underline",
                                        //                                     textDecorationStyle: "solid",
                                        //                                 } : {color: Colors.blackLight,}]}/>
                                        //                         </CustomView>
                                        //
                                        //                         <View style={{
                                        //                             height: Platform.OS === "web" ? "stretch" : "100%",
                                        //                             width: moderateScale(1),
                                        //                             backgroundColor: Colors.light43
                                        //                         }}/>
                                        //                         <View
                                        //                             style={{
                                        //                                 flex: .14,
                                        //                                 alignItems: 'center',
                                        //                                 justifyContent: 'center',
                                        //                                 marginVertical: moderateScale(2)
                                        //                             }}>
                                        //
                                        //                             <CustomView
                                        //                                 style={{
                                        //                                     flex: .14,
                                        //                                     alignItems: 'center',
                                        //                                     justifyContent: 'center'
                                        //                                 }}
                                        //                                 activeOpacity={mode ? .2 : 1}
                                        //                                 onPress={() => {
                                        //                                 }
                                        //                                 }
                                        //                             >
                                        //
                                        //                                 <HMTextView
                                        //                                     // numberOfLines={2}
                                        //                                     type={"bold"}
                                        //                                     text={item.PriorityName}
                                        //                                     style={[{
                                        //                                         fontSize: moderateScale(14),
                                        //
                                        //
                                        //                                         //  marginTop: moderateScale(4),
                                        //                                         textAlign: "center",
                                        //
                                        //
                                        //                                     }, mode ? {
                                        //                                         color: Colors.blue,
                                        //                                         textDecorationLine: "underline",
                                        //                                         textDecorationStyle: "solid",
                                        //                                     } : {color: item.PriorityColor ? item.PriorityColor : Colors.blackLight,}]}/>
                                        //                             </CustomView>
                                        //
                                        //                         </View>
                                        //                         <View style={{
                                        //                             height: Platform.OS === "web" ? "stretch" : "100%",
                                        //                             width: moderateScale(1),
                                        //                             backgroundColor: Colors.light43
                                        //                         }}/>
                                        //                         <View
                                        //                             style={{
                                        //                                 flex: .13,
                                        //                                 alignItems: 'center',
                                        //                                 justifyContent: 'center',
                                        //                                 marginVertical: moderateScale(2)
                                        //                             }}>
                                        //                             <CustomView
                                        //                                 style={{
                                        //                                     flex: .14,
                                        //                                     alignItems: 'center',
                                        //                                     justifyContent: 'center'
                                        //                                 }}
                                        //                                 activeOpacity={mode ? .2 : 1}
                                        //                                 onPress={() => {
                                        //
                                        //
                                        //                                 }
                                        //                                 }
                                        //                             >
                                        //
                                        //                                 <HMTextView
                                        //                                     // numberOfLines={2}
                                        //                                     type={"bold"}
                                        //                                     text={Extras.type == 3 || Extras.type == 4 ? (item.WorkTime ? item.WorkTime : " - ") : (item.WorkDate ? item.WorkDate : " - ")}
                                        //                                     style={[{
                                        //                                         fontSize: moderateScale(14),
                                        //
                                        //
                                        //                                         //  marginTop: moderateScale(4),
                                        //                                         textAlign: "center",
                                        //
                                        //
                                        //                                     }, mode ? {
                                        //                                         color: Colors.blue,
                                        //                                         textDecorationLine: "underline",
                                        //                                         textDecorationStyle: "solid",
                                        //                                     } : {color: Colors.blackLight,}]}/>
                                        //                             </CustomView>
                                        //
                                        //                         </View>
                                        //                         <View style={{
                                        //                             height: Platform.OS === "web" ? "stretch" : "100%",
                                        //                             width: moderateScale(1),
                                        //                             backgroundColor: Colors.light43
                                        //                         }}/>
                                        //                         <View
                                        //                             style={{
                                        //                                 flex: .14,
                                        //                                 alignItems: 'center',
                                        //                                 justifyContent: 'center',
                                        //                                 marginVertical: moderateScale(2)
                                        //                             }}>
                                        //                             <CustomView
                                        //                                 style={{
                                        //                                     flex: .14,
                                        //                                     alignItems: 'center',
                                        //                                     justifyContent: 'center'
                                        //                                 }}
                                        //                                 activeOpacity={mode ? .2 : 1}
                                        //                                 onPress={() => {
                                        //
                                        //
                                        //                                 }
                                        //                                 }
                                        //                             >
                                        //
                                        //                                 <HMTextView
                                        //                                     // numberOfLines={2}
                                        //                                     type={"bold"}
                                        //                                     text={(item.CreatorTask ? (`${item.CreatorTask.operator} (${item.CreatorTask.Name})`) : "") + (Extras.type == 3 || Extras.type == 4 ? "\n تاریخ ثبت : " + (item.CreateTime ? item.CreateTime : "") : "")}
                                        //                                     style={[{
                                        //                                         fontSize: moderateScale(13),
                                        //
                                        //
                                        //                                         //  marginTop: moderateScale(4),
                                        //                                         textAlign: "center",
                                        //
                                        //
                                        //                                     }, mode ? {
                                        //                                         color: Colors.blue,
                                        //                                         textDecorationLine: "underline",
                                        //                                         textDecorationStyle: "solid",
                                        //                                     } : {color: Colors.blackLight,}]}/>
                                        //                             </CustomView>
                                        //
                                        //                         </View>
                                        //                         <View style={{
                                        //                             height: Platform.OS === "web" ? "stretch" : "100%",
                                        //                             width: moderateScale(1),
                                        //                             backgroundColor: Colors.light43
                                        //                         }}/>
                                        //                         <View
                                        //                             style={{
                                        //                                 flex: .13,
                                        //                                 alignItems: 'center',
                                        //                                 justifyContent: 'center',
                                        //                                 marginVertical: moderateScale(2)
                                        //                             }}>
                                        //                             <CustomView
                                        //                                 style={{
                                        //                                     flex: .15,
                                        //                                     alignItems: 'center',
                                        //                                     justifyContent: 'center'
                                        //                                 }}
                                        //                                 activeOpacity={mode ? .2 : 1}
                                        //                                 onPress={() => {
                                        //
                                        //
                                        //                                 }
                                        //                                 }
                                        //                             >
                                        //
                                        //                                 <HMTextView
                                        //                                     // numberOfLines={2}
                                        //                                     type={"bold"}
                                        //                                     text={item.StatusName}
                                        //                                     style={[{
                                        //                                         fontSize: moderateScale(14),
                                        //
                                        //
                                        //                                         //  marginTop: moderateScale(4),
                                        //                                         textAlign: "center",
                                        //
                                        //
                                        //                                     }, mode ? {
                                        //                                         color: Colors.blue,
                                        //                                         textDecorationLine: "underline",
                                        //                                         textDecorationStyle: "solid",
                                        //                                     } : {color: item.StatusColor ? item.StatusColor : Colors.blackLight,}]}/>
                                        //                             </CustomView>
                                        //
                                        //                         </View>
                                        //                     </View>
                                        //
                                        //                 </View>
                                        //             }}
                                        //             renderFooter={this.renderFooter.bind(this)}
                                        //             columnCount={this.state.columnCount}
                                        //             initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                        //             refreshing={this.props.showRefresh}
                                        //             keyExtractor={(item, index) => index.toString()}
                                        //             data={this.props.results}
                                        //
                                        //
                                        //         />
                                        //     </View>
                                        //     :
                                        //     null
                                    }


                                    <HMFlatList
                                        data={this.props.results ? this.props.results : []}
                                        ListHeaderComponent={() => {
                                            return <View
                                                style={{
                                                    //  width: widthSlider,
                                                    width: "100%",
                                                    /// flex:1,
                                                    flexDirection: 'row',

                                                    marginTop: moderateScale(2),
                                                    // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)
                                                    //  paddingEnd: moderateScale((Platform.OS === "web" && !(isMobile)) ? moderateScale(12) : 0),
                                                    // alignSelf: 'center'
                                                    // marginVertical:moderateScale(6),
                                                }}>
                                                <View
                                                    style={{
                                                        width: '100%',
                                                        /// flex:1,
                                                        flexDirection: 'row',
                                                        backgroundColor: Colors.colorRow,
                                                        marginTop: moderateScale(2),
                                                        // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)
                                                        // paddingEnd: moderateScale(Platform.OS === "web" && !(navigator.userAgentData && navigator.userAgentData.mobile) ? 18 : 0),
                                                        // marginEnd: moderateScale(Platform.OS == "web" ? 10 : 0)

                                                        // alignSelf: 'center'
                                                        // marginVertical:moderateScale(6),
                                                    }}>

                                                    <View style={{
                                                        flex: .16,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginVertical: moderateScale(8),
                                                        //paddingHorizontal:moderateScale(4)

                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"عنوان گروه"}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.white
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.white
                                                    }}/>

                                                    <View style={{
                                                        flex: .16,
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        marginVertical: moderateScale(2),
                                                        //paddingHorizontal:moderateScale(4)

                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"عنوان وظیفه"}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.white
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.white
                                                    }}/>

                                                    <View style={{
                                                        flex: .14,
                                                        //flexDirection: "row",
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={Extras.type == 3 || Extras.type == 4 ? "تاریخ مشاهده" : "تاریخ ارجاع"}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",

                                                            }}/>

                                                        {/*       <HMIcon
                                                type={"MaterialCommunityIcons"}

                                                name={(this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                style={{
                                                    color: (this.state.typeSort === "count") ? "#2433ff" : "#185aa8",
                                                    fontSize: moderateScale(28),
                                                    //  padding: moderateScale(4),
                                                    alignSelf: "center",
                                                }}
                                                onPress={() => {
                                                    this.setState({
                                                            typeOrder: (this.state.typeSort === "count" && this.state.typeOrder === "desc") ? "asc" : "desc",
                                                            typeSort: "count",

                                                        },
                                                        () => {
                                                            this.getData(1)
                                                        }
                                                    )
                                                }}

                                            />*/}
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.white
                                                    }}/>
                                                    <View style={{
                                                        flex: .14,
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={"اولویت"}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.white,
                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",
                                                            }}/>
                                                        {/*    <HMIcon
                                                type={"MaterialCommunityIcons"}

                                                name={(this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                style={{
                                                    color: (this.state.typeSort === "doing") ? "#2433ff" : "#185aa8",
                                                    fontSize: moderateScale(28),
                                                    //  padding: moderateScale(4),
                                                    alignSelf: "center",
                                                }}
                                                onPress={() => {
                                                    this.setState({
                                                            typeOrder: (this.state.typeSort === "doing" && this.state.typeOrder === "desc") ? "asc" : "desc",
                                                            typeSort: "doing",

                                                        },
                                                        () => {
                                                            this.getData(1)
                                                        }
                                                    )
                                                }}

                                            />*/}
                                                    </View>

                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.white
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .13,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}

                                                    >
                                                        <TouchableOpacity

                                                            onPress={() => {
                                                                this.setState({
                                                                    resultModal: this.props.resultsAll.done,
                                                                    visibleModal: "Details"
                                                                })
                                                                /*    NavigationService.navigateParams("DetailsListTaskReportScreen", {
                                                                        item: this.props.resultsAll.done
                                                                    })*/
                                                            }}
                                                        >
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={Extras.type == 3 || Extras.type == 4 ? "تعداد روز کاری" : "مهلت انجام"}
                                                                style={[{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                    // textDecorationColor: "#000"
                                                                }
                                                                ]}/>
                                                        </TouchableOpacity>
                                                        {/*   <HMIcon
                                                type={"MaterialCommunityIcons"}

                                                name={(this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                style={{
                                                    color: (this.state.typeSort === "done") ? "#2433ff" : "#185aa8",
                                                    fontSize: moderateScale(28),
                                                    //  padding: moderateScale(4),
                                                    alignSelf: "center",
                                                }}
                                                onPress={() => {
                                                    this.setState({
                                                            typeOrder: (this.state.typeSort === "done" && this.state.typeOrder === "desc") ? "asc" : "desc",
                                                            typeSort: "done",

                                                        },
                                                        () => {
                                                            this.getData(1)
                                                        }
                                                    )
                                                }}

                                            />*/}
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.white
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .14,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}

                                                    >
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                this.setState({
                                                                    resultModal: this.props.resultsAll.others,
                                                                    visibleModal: "Details"
                                                                })
                                                                /*     NavigationService.navigateParams("DetailsListTaskReportScreen", {
                                                                         item: this.props.resultsAll.others
                                                                     })*/
                                                            }}
                                                        >
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={"ثبت توسط"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                    // textDecorationColor: "#000"
                                                                }}/>
                                                        </TouchableOpacity>
                                                        {/*       <HMIcon
                                                type={"MaterialCommunityIcons"}

                                                name={(this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                style={{
                                                    color: (this.state.typeSort === "other") ? "#2433ff" : "#185aa8",
                                                    fontSize: moderateScale(28),
                                                    //  padding: moderateScale(4),
                                                    alignSelf: "center",
                                                }}
                                                onPress={() => {
                                                    this.setState({
                                                            typeOrder: (this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "asc" : "desc",
                                                            typeSort: "other",

                                                        },
                                                        () => {
                                                            this.getData(1)
                                                        }
                                                    )
                                                }}

                                            />*/}
                                                    </View>
                                                    <View style={{
                                                        height: '100%',
                                                        width: moderateScale(1),
                                                        alignSelf: 'center',
                                                        backgroundColor: Colors.white
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .13,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}

                                                    >
                                                        <TouchableOpacity
                                                            onPress={() => {
                                                                this.setState({
                                                                    resultModal: this.props.resultsAll.others,
                                                                    visibleModal: "Details"
                                                                })
                                                                /*     NavigationService.navigateParams("DetailsListTaskReportScreen", {
                                                                         item: this.props.resultsAll.others
                                                                     })*/
                                                            }}
                                                        >
                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={"وضعیت"}
                                                                style={{
                                                                    fontSize: moderateScale(13),

                                                                    color: Colors.white,
                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",
                                                                    // textDecorationLine: "underline",
                                                                    // textDecorationStyle: "solid",
                                                                    // textDecorationColor: "#000"
                                                                }}/>
                                                        </TouchableOpacity>
                                                        {/*       <HMIcon
                                                type={"MaterialCommunityIcons"}

                                                name={(this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "sort-descending" : "sort-ascending"}
                                                style={{
                                                    color: (this.state.typeSort === "other") ? "#2433ff" : "#185aa8",
                                                    fontSize: moderateScale(28),
                                                    //  padding: moderateScale(4),
                                                    alignSelf: "center",
                                                }}
                                                onPress={() => {
                                                    this.setState({
                                                            typeOrder: (this.state.typeSort === "other" && this.state.typeOrder === "desc") ? "asc" : "desc",
                                                            typeSort: "other",

                                                        },
                                                        () => {
                                                            this.getData(1)
                                                        }
                                                    )
                                                }}

                                            />*/}
                                                    </View>

                                                </View>

                                            </View>
                                        }}
                                        renderItem={({item, index}) => {

                                            return <View
                                                style={{
                                                    width: "100%",
                                                    // flex: 1,
                                                    overflow: 'hidden',
                                                    //height: HeightItem,
                                                    // padding: moderateScale(4),
                                                    //  margin:moderateScale(5),
                                                    borderWidth: moderateScale(1),
                                                    // borderRadius: moderateScale(2),
                                                    borderColor: '#ddd',
                                                    // borderBottomWidth: 0,
                                                    // shadowColor: '#000',
                                                    // shadowOffset: {width: 0, height: moderateScale(.7)},
                                                    // shadowOpacity: 0.6,
                                                    // shadowRadius: moderateScale(2),
                                                    elevation: moderateScale(1),
                                                    // marginLeft: moderateScale(1),
                                                    // marginRight: moderateScale(1),
                                                    // marginTop: moderateScale(1),
                                                    // marginBottom: moderateScale(1),
                                                    backgroundColor: Colors.white,
                                                }}>
                                                <View
                                                    style={{
                                                        width: '100%',
                                                        flexDirection: 'row',
                                                        backgroundColor: Colors.white,


                                                        // alignSelf: 'center'
                                                        // marginVertical:moderateScale(6),
                                                    }}>

                                                    <TouchableOpacity
                                                        style={{
                                                            flex: .16,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(14),

                                                            //  paddingHorizontal: moderateScale(4)
                                                        }}
                                                        onPress={() => {
                                                            NavigationService.navigateParams("DetailsTaskOperationSatiaScreen", {
                                                                item: item,
                                                                itemExtra: item,
                                                                itemExtraParent: Extras,
                                                                // type: type,
                                                                indexExtra: index
                                                            })
                                                            //   DetailsTaskOperationSatiaScreen
                                                        }}
                                                    >
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.Name}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.blackLight,
                                                                // textDecorationLine: "underline",
                                                                // textDecorationStyle: "solid",
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </TouchableOpacity>
                                                    <View style={{
                                                        height: Platform.OS === "web" ? "stretch" : "100%",
                                                        width: moderateScale(1),
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .16,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2),
                                                            //  paddingHorizontal: moderateScale(4)
                                                        }}

                                                    >
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.Title}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.blackLight,
                                                                // textDecorationLine: "underline",
                                                                // textDecorationStyle: "solid",
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>
                                                    </View>
                                                    <View style={{
                                                        height: Platform.OS === "web" ? "stretch" : "100%",
                                                        width: moderateScale(1),
                                                        backgroundColor: Colors.light43
                                                    }}/>

                                                    <CustomView
                                                        style={{
                                                            flex: .14,
                                                            alignItems: 'center',
                                                            justifyContent: 'center'
                                                        }}
                                                        activeOpacity={mode ? .2 : 1}
                                                        onPress={() => {
                                                        }
                                                        }
                                                    >
                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            text={item.CreateTime_fa ? item.CreateTime_fa : " - "}

                                                            style={[{
                                                                fontSize: moderateScale(14),


                                                                //  marginTop: moderateScale(4),
                                                                textAlign: "center",


                                                            }, mode ? {
                                                                color: Colors.blue,
                                                                textDecorationLine: "underline",
                                                                textDecorationStyle: "solid",
                                                            } : {color: Colors.blackLight,}]}/>
                                                    </CustomView>

                                                    <View style={{
                                                        height: Platform.OS === "web" ? "stretch" : "100%",
                                                        width: moderateScale(1),
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .14,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>

                                                        <CustomView
                                                            style={{
                                                                flex: .14,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}
                                                            onPress={() => {
                                                            }
                                                            }
                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.PriorityName}
                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blue,
                                                                    textDecorationLine: "underline",
                                                                    textDecorationStyle: "solid",
                                                                } : {color: item.PriorityColor ? item.PriorityColor : Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                    <View style={{
                                                        height: Platform.OS === "web" ? "stretch" : "100%",
                                                        width: moderateScale(1),
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .13,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>
                                                        <CustomView
                                                            style={{
                                                                flex: .14,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}
                                                            onPress={() => {


                                                            }
                                                            }
                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={Extras.type == 3 || Extras.type == 4 ? (item.WorkTime ? item.WorkTime : " - ") : (item.WorkDate ? item.WorkDate : " - ")}
                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blue,
                                                                    textDecorationLine: "underline",
                                                                    textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                    <View style={{
                                                        height: Platform.OS === "web" ? "stretch" : "100%",
                                                        width: moderateScale(1),
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .14,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>
                                                        <CustomView
                                                            style={{
                                                                flex: .14,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}
                                                            onPress={() => {


                                                            }
                                                            }
                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={(item.CreatorTask ? (`${item.CreatorTask.operator} (${item.CreatorTask.Name})`) : "") + (Extras.type == 3 || Extras.type == 4 ? "\n تاریخ ثبت : " + (item.CreateTime ? item.CreateTime : "") : "")}
                                                                style={[{
                                                                    fontSize: moderateScale(13),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blue,
                                                                    textDecorationLine: "underline",
                                                                    textDecorationStyle: "solid",
                                                                } : {color: Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                    <View style={{
                                                        height: Platform.OS === "web" ? "stretch" : "100%",
                                                        width: moderateScale(1),
                                                        backgroundColor: Colors.light43
                                                    }}/>
                                                    <View
                                                        style={{
                                                            flex: .13,
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            marginVertical: moderateScale(2)
                                                        }}>
                                                        <CustomView
                                                            style={{
                                                                flex: .15,
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            activeOpacity={mode ? .2 : 1}
                                                            onPress={() => {


                                                            }
                                                            }
                                                        >

                                                            <HMTextView
                                                                // numberOfLines={2}
                                                                type={"bold"}
                                                                text={item.StatusName}
                                                                style={[{
                                                                    fontSize: moderateScale(14),


                                                                    //  marginTop: moderateScale(4),
                                                                    textAlign: "center",


                                                                }, mode ? {
                                                                    color: Colors.blue,
                                                                    textDecorationLine: "underline",
                                                                    textDecorationStyle: "solid",
                                                                } : {color: item.StatusColor ? item.StatusColor : Colors.blackLight,}]}/>
                                                        </CustomView>

                                                    </View>
                                                </View>

                                            </View>

                                        }}
                                        //   keyExtractor={(item, index) => item.StatusName}
                                        keyExtractor={(item, index) => index.toString() + (item.StatusName)}

                                        ListEmptyComponent={() =>
                                            null}
                                        // ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                         ListFooterComponent={this.renderFooter.bind(this)}
                                        refreshing={this.props.showRefresh}
                                        onRefresh={this.handleRefresh.bind(this)}
                                        onEndReached={this.handleLoadMore.bind(this)}
                                        initialNumToRender={(typeExport._Count / this.state.columnCount) - 1}
                                        onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                        getItemLayout={(data, index) => ({
                                            length: moderateScale(85),
                                            offset: moderateScale(85) * index,
                                            index
                                        })}
                                        // initialNumToRender={5}
                                        // maxToRenderPerBatch={10}
                                        // windowSize={10}
                                    />
                                </View>
                                {/*   <TouchableOpacity
                                    onPress={() => {
                                        this.setState({
                                            visibleModal: "Filter"
                                        })
                                    }}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        overflow: 'hidden',
                                        width: moderateScale(48),
                                        height: moderateScale(48),
                                        borderRadius: moderateScale(24),
                                        // padding: moderateScale(4),
                                        margin: moderateScale(5),
                                        borderWidth: moderateScale(1),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {width: 0, height: moderateScale(.7)},
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        // marginLeft: moderateScale(1),
                                        // marginRight: moderateScale(1),
                                        // marginTop: moderateScale(1),
                                        // marginBottom: moderateScale(1),
                                        backgroundColor: Colors.colorSecondPrimary,
                                        alignItems: 'center',
                                        justifyContent: "center"
                                    }}>
                                    <HMIcon
                                        type={"Feather"}
                                        name="filter"
                                        style={{
                                            color: Colors.white,
                                            fontSize: moderateScale(28),
                                            //  padding: moderateScale(4),
                                            alignSelf: "center",
                                        }}/>
                                </TouchableOpacity>*/}
                                {
                                    (this.props.showLoading || this.props.showRefresh) && this.props.page == 1 ?
                                        <DialogLoadingCustomize/>
                                        : null
                                }

                                {
                                    this.props.NoInternetDialog ?
                                        <DialogConnectionCustomize
                                            onPress={() => this.getData(this.props.page)}/> : null
                                }
                                {
                                    // this.state.showDialogDate ?
                                    //     <HMDialogSelectDate
                                    //         DateTo={this.state.DateTo}
                                    //         DateFrom={this.state.DateFrom}
                                    //         onPressOk={this.setDate}
                                    //         onPressCancel={() => {
                                    //             this.setState({
                                    //                 showDialogDate: false
                                    //             })
                                    //         }}
                                    //     />
                                    //
                                    //     :
                                    //
                                    //     null
                                }

                                <HMModalSearch
                                    visibleModal={this.state.visibleModal === 'Modal'}
                                    hiddenModal={() => this.hiddenModal()}
                                    textInput={this.state["text" + this.state.indexFilter]}
                                    SearchFilterFunction={text => this.SearchFilterFunction("array", "text", text, childFilter)}
                                    //textInput={this.state.mobile}
                                    dataSource={this.state["dataSource" + this.state.indexFilter]}
                                    // onChange={() => this.onChangeCondition(index, item)}
                                    onChangeItem={this.onChange}
                                />
                                {this.renderModal()}
                            </View>
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    renderModal(data) {
        let item = this.state.resultModal;
        return (
            <HMModal
                isVisible={this.state.visibleModal === "Details" || this.state.visibleModal === "Filter"}
                //visible={this.state.visibleModal}
                backdropColor={Colors.gray}
                backdropOpacity={0.8}
                animationIn="zoomInDown"
                animationOut="zoomOutUp"
                animationInTiming={600}
                animationOutTiming={600}
                backdropTransitionInTiming={600}
                backdropTransitionOutTiming={600}
                //style={{height: '60%'}}
                onBackdropPress={() => this.hiddenModal()}
                onBackButtonPress={() => this.hiddenModal()}

                animationType="slide"
                // transparent={true}
            >

                <View style={[Platform.OS === 'web' ? {width: "90%",} : {},
                    {

                        padding: moderateScale(16),
                        backgroundColor: Colors.white,
                        border: moderateScale(4),

                    }]}>

                    <ScrollView
                        style={{
                            width: '100%'

                        }}
                        ref={scroll => this._scroll = scroll}
                        keyboardShouldPersistTaps="handled"
                    >
                        {

                            this.state.visibleModal === "Details" ?

                                (item ? <View
                                            style={{
                                                style: 1,
                                                overflow: 'hidden',
                                                //   height: HeightItem,
                                                // padding: moderateScale(4),
                                                //  margin:moderateScale(5),
                                                borderWidth: moderateScale(1),
                                                borderRadius: moderateScale(2),
                                                borderColor: '#ddd',
                                                borderBottomWidth: 0,
                                                shadowColor: '#000',
                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                shadowOpacity: 0.6,
                                                shadowRadius: moderateScale(2),
                                                elevation: moderateScale(1),
                                                margin: moderateScale(4),
                                                padding: moderateScale(4),
                                                // marginLeft: moderateScale(1),
                                                // marginRight: moderateScale(1),
                                                // marginTop: moderateScale(1),
                                                // marginBottom: moderateScale(1),
                                                backgroundColor: Colors.white,
                                            }}>
                                            <View
                                                style={{margin: moderateScale(6), alignItems: "center",}}>
                                                {
                                                    !item.image ?
                                                        null
                                                        :
                                                        <View style={{
                                                            width: moderateScale(48),
                                                            height: moderateScale(48),
                                                            marginBottom: moderateScale(10)
                                                        }}>
                                                            <HMImageView
                                                                // resizeMode={FastImage.resizeMode.contain}
                                                                resizeMode={"contain"}
                                                                _backgroundColorLoading={Platform.OS === "web" ? Colors.transparent : null}

                                                                //  uriComplete={"https://cdnw.elicdn.com/Blog/wp-content/uploads/2018/03/%D8%B9%DA%A9%D8%B3-%D8%A7%D8%B5%D9%84%DB%8C-%D9%85%D8%AA%D9%86-%D9%87%D8%A7-%D8%A8%D8%A7-%D9%84%D9%88%DA%AF%D9%88-25.jpg"}
                                                                uriComplete={item.image}
                                                                //source_image={item.image}
                                                                styleText={{marginTop: moderateScale(10)}}
                                                                borderRadius={4}/>

                                                        </View>
                                                }

                                                <HMTextView
                                                    // numberOfLines={2}
                                                    type={"bold"}
                                                    //text={item.subject}
                                                    text={item && item.label ? item.label : ""}
                                                    style={{
                                                        fontSize: moderateScale(14),

                                                        color: Colors.blackLight,
                                                        marginHorizontal: moderateScale(6),
                                                        //  textAlign: "right",
                                                    }}/>
                                            </View>
                                            <FlatList
                                                data={item && item.list ? item.list : []}

                                                renderItem={({item, index}) => {

                                                    return <View
                                                        style={{
                                                            //width: "100%",
                                                            flex: 1,
                                                            flexDirection: "row",
                                                            marginVertical: moderateScale(4),
                                                            // overflow: 'hidden',
                                                            // //   height: HeightItem,
                                                            // // padding: moderateScale(4),
                                                            // //  margin:moderateScale(5),
                                                            // borderWidth: moderateScale(1),
                                                            // borderRadius: moderateScale(2),
                                                            // borderColor: '#ddd',
                                                            // borderBottomWidth: 0,
                                                            // shadowColor: '#000',
                                                            // shadowOffset: {width: 0, height: moderateScale(.7)},
                                                            // shadowOpacity: 0.6,
                                                            // shadowRadius: moderateScale(2),
                                                            // elevation: moderateScale(1),
                                                            // margin: moderateScale(4),
                                                            // padding: moderateScale(4),
                                                            // // marginLeft: moderateScale(1),
                                                            // // marginRight: moderateScale(1),
                                                            // // marginTop: moderateScale(1),
                                                            // // marginBottom: moderateScale(1),
                                                            // backgroundColor: Colors.white,
                                                        }}>

                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            //text={item.subject}
                                                            text={` - ${(index + 1)}`}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.colorDarkText
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>

                                                        <HMTextView
                                                            // numberOfLines={2}
                                                            type={"bold"}
                                                            //text={item.subject}
                                                            text={item && item.label ? item.label : ""}
                                                            style={{
                                                                fontSize: moderateScale(13),

                                                                color: Colors.colorDarkText
                                                                //  marginTop: moderateScale(4),
                                                                //  textAlign: "right",
                                                            }}/>


                                                    </View>

                                                }}
                                                keyExtractor={(item, index) => index.toString()}
                                                ListEmptyComponent={() =>
                                                    null}
                                                // ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                                //  ListFooterComponent={this.renderFooter.bind(this)}
                                                // refreshing={this.props.showRefresh}
                                                // onRefresh={this.handleRefresh.bind(this)}
                                                // onEndReached={this.handleLoadMore.bind(this)}
                                                // initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}

                                                // getItemLayout={(data, index) => ({
                                                //     length: moderateScale(85),
                                                //     offset: moderateScale(85) * index,
                                                //     index
                                                // })}
                                                // initialNumToRender={5}
                                                // maxToRenderPerBatch={10}
                                                // windowSize={10}
                                            />
                                        </View>
                                        :
                                        null
                                )
                                :
                                (
                                    this.state.visibleModal === "Filter" ?
                                        <View
                                            style={{
                                                style: 1,
                                                overflow: 'hidden',
                                                //   height: HeightItem,
                                                // padding: moderateScale(4),
                                                //  margin:moderateScale(5),
                                                borderWidth: moderateScale(1),
                                                borderRadius: moderateScale(2),
                                                borderColor: '#ddd',
                                                borderBottomWidth: 0,
                                                shadowColor: '#000',
                                                shadowOffset: {width: 0, height: moderateScale(.7)},
                                                shadowOpacity: 0.6,
                                                shadowRadius: moderateScale(2),
                                                elevation: moderateScale(1),
                                                margin: moderateScale(4),
                                                padding: moderateScale(4),
                                                // marginLeft: moderateScale(1),
                                                // marginRight: moderateScale(1),
                                                // marginTop: moderateScale(1),
                                                // marginBottom: moderateScale(1),
                                                backgroundColor: Colors.white,
                                            }}>
                                            <View
                                                style={{
                                                    width: '100%',
                                                    //flexDirection: 'row',
                                                    // alignItems: 'center',
                                                    padding: moderateScale(2),
                                                    marginVertical: moderateScale(10)

                                                }}>
                                                {
                                                    this.state.messageModal ?
                                                        <HMTextView
                                                            type={"bold"}
                                                            text={this.state.messageModal}
                                                            //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                            style={{
                                                                color: Colors.red,
                                                                fontSize: moderateScale(14),
                                                                textAlign: "center",
                                                                marginVertical: moderateScale(8),
                                                                //   marginEnd: moderateScale(10),

                                                            }}
                                                            styleRoot={{alignSelf: "center"}}
                                                        />
                                                        :
                                                        null
                                                }
                                                <View
                                                    style={{
                                                        // width: moderateScale(80),
                                                        paddingHorizontal: moderateScale(4)
                                                    }}>
                                                    <HMTextView
                                                        type={"bold"}
                                                        text={"مرتب سازی بر اساس : "}
                                                        //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                        style={{
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(14),
                                                            //   marginEnd: moderateScale(10),

                                                        }}/>
                                                </View>
                                                <View style={{flex: 1,}}>
                                                    <HMSelectInput
                                                        onValueChange={(value) => {


                                                            let idx = container.state.listSortFilter.findIndex(obj => obj.value == value);
                                                            let res = null;
                                                            if (idx !== -1) {
                                                                res = container.state.listSortFilter[idx]
                                                            }

                                                            this.setState({
                                                                messageModal: null,
                                                                SelectSortFilterValue: value,
                                                                SelectSortFilter: res ? {
                                                                    label: res.label,
                                                                    value: res.value,
                                                                    index: idx
                                                                } : {
                                                                    label: i18n.t('constant.SelectItem'),
                                                                    value: idx,
                                                                    index: idx
                                                                }
                                                            })
                                                        }}
                                                        // error={this.state.errorSelectInput}
                                                        //
                                                        // //  requestServerRetry={container.getServerTypeDocuments}
                                                        // requestServer={() => {
                                                        // }}
                                                        value={this.state.SelectSortFilterValue ? "" : i18n.t('constant.SelectItem')}
                                                        index={this.state.Modem ? this.state.SelectSortFilter.index : -1}
                                                        itemSelectInput={this.state.SelectSortFilter}
                                                        options={this.state.listSortFilter}

                                                        styleRoot={{
                                                            width: '100%'
                                                        }}
                                                    />
                                                </View>

                                            </View>
                                            <View
                                                style={{
                                                    width: '100%',
                                                    //flexDirection: 'row',
                                                    //alignItems: 'center',
                                                    padding: moderateScale(2),
                                                    marginBottom: moderateScale(10)

                                                }}>

                                                <View
                                                    style={{
                                                        // width: moderateScale(80),
                                                        paddingHorizontal: moderateScale(4)
                                                    }}>
                                                    <HMTextView
                                                        type={"bold"}
                                                        text={"ترتیب مرتب سازی : "}
                                                        //   text={"مدارک خود را به فرمت عکس  بارگذاری نمایید"}

                                                        style={{
                                                            color: Colors.blackLight,
                                                            fontSize: moderateScale(14),
                                                            textAlign: "center",
                                                            //   marginEnd: moderateScale(10),

                                                        }}/>
                                                </View>

                                                <View style={{flex: 1,}}>
                                                    <HMSelectInput
                                                        onValueChange={(value) => {


                                                            let idx = container.state.listOrderFilter.findIndex(obj => obj.value == value);
                                                            let res = null;
                                                            if (idx !== -1) {
                                                                res = container.state.listOrderFilter[idx]
                                                            }

                                                            this.setState({
                                                                messageModal: null,
                                                                SelectOrderFilterValue: value,
                                                                OrderFilter: res ? {
                                                                    label: res.label,
                                                                    value: res.value,
                                                                    index: idx
                                                                } : {
                                                                    label: i18n.t('constant.SelectItem'),
                                                                    value: idx,
                                                                    index: idx
                                                                }
                                                            })
                                                        }}
                                                        // error={this.state.errorSelectInput}
                                                        //
                                                        // //  requestServerRetry={container.getServerTypeDocuments}
                                                        // requestServer={() => {
                                                        // }}
                                                        value={this.state.SelectOrderFilterValue ? "" : i18n.t('constant.SelectItem')}
                                                        index={this.state.OrderFilter ? this.state.OrderFilter.index : -1}
                                                        itemSelectInput={this.state.OrderFilter}
                                                        options={this.state.listOrderFilter}

                                                        styleRoot={{
                                                            width: '100%'
                                                        }}
                                                    />
                                                </View>

                                            </View>
                                            <TouchableOpacity
                                                onPress={() => {
                                                    if (!this.state.SelectSortFilterValue || !this.state.SelectOrderFilterValue)
                                                        this.setState({
                                                                messageModal: !this.state.SelectSortFilterValue ? "نوع مرتب سازی را مشخص نمایید" : "ترتیب مرتب سازی را مشخص نمایید",
                                                            },
                                                            () => {
                                                            })
                                                    else
                                                        this.setState({

                                                                typeSort: this.state.SelectSortFilterValue,
                                                                typeOrder: this.state.SelectOrderFilterValue,
                                                                visibleModal: "",
                                                            },
                                                            () => {
                                                                this.getData(1)
                                                            })


                                                }}
                                                style={{
                                                    //width: '96%',
                                                    padding: moderateScale(6),
                                                    height: moderateScale(33),
                                                    backgroundColor: Colors.colorPrimary,
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    alignSelf: 'center',
                                                    flexDirection: 'row',
                                                    marginVertical: moderateScale(4),
                                                    marginHorizontal: moderateScale(4),
                                                    borderRadius: moderateScale(8)
                                                }}>

                                                {/*      <HMIcon name={"reload"}
                                                style={{
                                                    fontSize: moderateScale(20),
                                                    color: Colors.white,
                                                    textAlign: "center",
                                                    padding: moderateScale(4),

                                                }}/>
*/}
                                                <HMTextView
                                                    numberOfLines={1}
                                                    type={"bold"}
                                                    // text={" اگر در سازمان شما هم افراد مغرور و شخصیت های قوی وجود دارد لازم است بدانید، هنر فرگوسن این بود که به تمام"}
                                                    text={"اعمال فیلتر"}
                                                    style={{
                                                        fontSize: moderateScale(14),
                                                        color: Colors.white,
                                                        marginHorizontal: moderateScale(4),
                                                        //  marginTop: moderateScale(4),
                                                        textAlign: "center",
                                                    }}/>


                                            </TouchableOpacity>
                                        </View>
                                        :
                                        null
                                )


                        }
                    </ScrollView>
                    {
                        this.props.isLoadingSet ?
                            <DialogLoadingCustomize/>
                            : null
                    }

                </View>


            </HMModal>
        );
    }

    renderItemFilter = ({item, index}) => {

        //let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
        let idx = this.state.arraySelected.findIndex(obj => obj.index === index);
        let checkIndex = (idx !== -1);

        return <View
            onPress={() => {

            }
            }
            style={{
                flex: 1,
                flexDirection: 'row',
                paddingHorizontal: moderateScale(3),
                // backgroundColor: checkIndex ? Colors.colorPrimary : Colors.transparent,

                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(8),
                marginVertical: moderateScale(4),

            }}
        >
            {
                <View
                    style={[{
                        //marginVertical: moderateScale(15),
                        //   height: moderateScale(85),
                        alignItems: 'center',
                        //justifyContent: 'center',
                        flexDirection: 'row'
                    }]}>
                    {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                    {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                    {
                        checkIndex ?

                            <View style={{flexDirection: 'row'}}>


                                <TouchableOpacity
                                    onPress={() => {
                                        //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                        let arr = this.state.arraySelected;

                                        if (idx !== -1) {
                                            arr.splice(idx, 1)

                                            container.setState({
                                                    arraySelected: arr,
                                                    [`selectFilter${index}`]: {
                                                        value: item.name,
                                                        id: item.id,
                                                        type: item.type
                                                    },
                                                    visibleModal: '',
                                                },

                                                () => {
                                                    this.getData(1)
                                                }
                                            )
                                        }
                                        // container.setState({
                                        //         [`selectFilter${index}`]: {
                                        //             value: item.name,
                                        //             id: item.id,
                                        //             type:item.type
                                        //         },
                                        //         visibleModal: '',
                                        //     },
                                        //     () => {
                                        //         let arr = this.state.arraySelected;
                                        //         this.setState({
                                        //                 arraySelected: arr
                                        //             },
                                        //             () => {
                                        //                 container.getData(1)
                                        //             }
                                        //         )
                                        //
                                        //     }
                                        // )

                                    }}
                                    style={{
                                        alignSelf: 'center',
                                        //  marginHorizontal:moderateScale(6)
                                    }}>
                                    <HMIcon name={"md-close"} style={{
                                        fontSize: moderateScale(24),
                                        color: '#f20042'
                                    }}/>

                                </TouchableOpacity>
                            </View>
                            :
                            null


                    }

                    <TouchableOpacity
                        onPress={() => {

                            this.setState({
                                    indexFilter: index,
                                    typeFilter: item.type,
                                    ["dataSource" + index]: item.list
                                },
                                () => {

                                    if (item.type == "2") {
                                        this.setState({
                                            showDialogDate: true
                                        })
                                    }
                                    else
                                    //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                        this.onShow('Modal')

                                })
                        }
                        }

                        style={{flexDirection: "row", alignItems: 'center',}}
                    >
                        <View style={{width: moderateScale(48), height: moderateScale(48)}}>
                            <HMImageView
                                resizeMode={'contain'}
                                uriComplete={item.image}
                                _backgroundColorLoading={Colors.transparent}
                                styleImage={{
                                    //  resizeMode: 'cover',
                                    width: "100%",
                                    height: "100%",
                                    //   backgroundColor: "#ee7e0c",
                                    //  borderTopRightRadius:moderateScale(8),
                                    // borderTopEndRadius: moderateScale(12),
                                    // borderTopStartRadius: moderateScale(8),
                                    borderRadius: moderateScale(10),

                                }}
                                //  onLoad={this._onLoad}
                                //   onError={status !== 3 ? this._onError : undefined} // prevent infinite-loop bug
                            />
                        </View>
                        {/*     <HMTextView
                            // text={this.SelectNameFilter(item, index) +" : "} type={"bold"}
                            text={item.name + " : "} type={"bold"}
                            style={{
                                color: Colors.blackLight,
                                marginHorizontal: moderateScale(6),
                                fontSize: moderateScale(13),
                                textAlign: 'center',

                            }}/>*/}
                        <HMTextView
                            text={item.type == "2" ? (this.state.DateTo || this.state.DateFrom ? this.state.DateFrom + " لغایت " + this.state.DateTo : "") : (checkIndex ? this.SelectNameFilter(item, index, idx) : " همه مناطق ")}
                            type={"bold"}
                            style={{
                                marginHorizontal: moderateScale(6),
                                fontSize: moderateScale(13),
                                textAlign: 'center',
                                color: Colors.blue,
                                textDecorationLine: "underline",
                                textDecorationStyle: "solid",

                            }}/>
                        {/*     <HMIcon name={"ios-arrow-down"} style={{
                            fontSize: moderateScale(13),
                            color: checkIndex ? '#f2f2f2' : Colors.gray,
                            marginHorizontal: moderateScale(2),
                            marginTop: moderateScale(3)
                        }}/>*/}
                    </TouchableOpacity>


                </View>

            }
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    setDate(DateFrom, DateTo) {
        container.setState({
                DateFrom, DateTo, showDialogDate: false,
                indexSelectMonthType: container.state.indexSelectMonthTypePrevious,

            },
            () => {
                container.getData(1)
            }
        )
    }

    renderItem = ({item, index}) => {
        return <View/>
    }

    checkSelect(item, index) {
        let l = this.state["selectFilter" + index];
        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index, idx) {
        //let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        //  let l = this.state["selectFilter" + index]
        let l = idx !== -1 ? this.state.arraySelected[idx] : {}
        // let l = idx !== -1 ? this.state["selectFilter" + index] : {}

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }


    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashSatiaScreen.Connection) {
            this.getData(1)
        } else {
            // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListTaskOperationSatiaScreen, `?type=${this.props.typee}&city=`, TypeGetListTaskOperationSatiaScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {
        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashSatiaScreen.Connection) {
            // this.props.callService(urlListTaskOperationSatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListTaskOperationSatiaScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    /*   onChange(index, data) {

           let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
           let arr = container.state.arraySelected;

           if (idx !== -1) {
               arr.splice(idx, 1)

               container.setState({
                       arraySelected: arr
                   },

                   () => {
                       //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                       container.state.arraySelected.push({
                           index: container.state.indexFilter,
                           data: data,
                           id: data.id,
                           value: data.name,
                           type: container.state.typeFilter
                       })
                   }
               )

           } else {
               container.state.arraySelected.push({
                   index: container.state.indexFilter,
                   data: data,
                   id: data.id,
                   value: data.name,
                   type: container.state.typeFilter
               })
               // arr = [...newState.listFilter, {...action.data}]
               // newState.listFilter = arr
           }

           let l = container.state.indexFilter

           container.setState({
                   [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                   //indexFilterCondition: index,
                   visibleModal: '',
               },
               () => {
                   container.getData(1)
               }
           )
       }*/

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arraySelected = container.state.arraySelected.slice();
        let {indexFilter} = container.state

        if (idx !== -1) {
            // arraySelected.splice(idx, 1)
            // arraySelected.push({
            //     index: container.state.indexFilter,
            //     data: data,
            //     id: data.id,
            //     value: data.name,
            //     type: container.state.typeFilter,
            //     indexFilter: indexFilter,
            // })
            arraySelected[idx] = {
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter,
                indexFilter: indexFilter,
            };
            container.setState({
                    arraySelected,
                    visibleModal: '',
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    // container.state.arraySelected.push({
                    //     index: container.state.indexFilter,
                    //     data: data,
                    //     id: data.id,
                    //     value: data.name,
                    //     type: container.state.typeFilter
                    // })
                }
            )

        } else {

            arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter,
                indexFilter: indexFilter,
            })
            container.setState({
                    arraySelected,
                    visibleModal: '',

                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    // container.state.arraySelected.push({
                    //     index: container.state.indexFilter,
                    //     data: data,
                    //     id: data.id,
                    //     value: data.name,
                    //     type: container.state.typeFilter
                    // })
                }
            )
            // container.state.arraySelected.push({
            //     index: container.state.indexFilter,
            //     data: data,
            //     id: data.id,
            //     value: data.name,
            //     type: container.state.typeFilter
            // })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }


        container.setState({
                [`selectFilter${indexFilter}`]: {
                    value: data.name,
                    id: data.id,
                    type: container.state.typeFilter,
                    indexFilter: indexFilter
                },
                //indexFilterCondition: index,
                visibleModal: '',
                gdomId: container.state.typeFilter == "1" ? data.id : container.state.gdomId
            },
            () => {
                container.getData(1)
            }
        )
    }

    hiddenModal() {
        this.setState({
                visibleModal: '',
                messageModal: null,
            },
            () => {
            })
    }

    onShow(data) {
        this.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

}

//export default withNavigationFocus(ListTaskOperationSatiaScreen);
export default ListTaskOperationSatiaScreen;
